import { schema } from 'normalizr'

const takeoutOrder = new schema.Entity('takeoutOrders')

export default takeoutOrder
